"use strict";
module.exports = {
  Event: require('./Event'),
  UIEvent: require('./UIEvent'),
  MouseEvent: require('./MouseEvent'),
  CustomEvent: require('./CustomEvent')
};
